import { useKeycloak } from "@react-keycloak/web";
import useHasRole from "hooks/useHasRole";
import { Navigate, Outlet, useLocation } from "react-router-dom";

type RealmRole =
  | "stratesys"
  | "uverifyCorte"
  | "uverifyKuo"
  | "uverifyInfra"
  | "uverifyValbruna";
type ResourceRole = "buyer" | "supplier" | "worker" | "admin";
type FeatureRole =
  | "cargaMassiva"
  | "sowProfile"
  | "subcontractors"
  | "consolidatedWorkers";

type Role = RealmRole | ResourceRole | FeatureRole;

interface RequireRoleProps {
  roles: Role[];
}

export default function RequireRole({ roles }: RequireRoleProps) {
  const { hasRealmRole, hasResourceRole } = useHasRole();
  const { keycloak } = useKeycloak();
  const location = useLocation();

  const hasRoles = (): boolean => {
    let hasRoles = false;

    roles.forEach((role) => {
      hasRoles = hasRealmRole([role]) || hasResourceRole([role, "uverify"]);
    });

    return hasRoles;
  };

  const redirectBasedOnAuthentication = keycloak?.authenticated
    ? "/app/unauthorized"
    : "/auth/login";

  return hasRoles() 
    ? <Outlet /> 
    : <Navigate to={redirectBasedOnAuthentication} state={{ from: location }} replace />
}
